// `React` in scope for the classic-runtime renderchecks — see `CrossIcon`.
import React from "react";
import { CheckMark } from "@rista/ui/library/icons/glyphs";

// The drawing is the design system's icon glyph (`@rista/ui/library/icons/glyphs`, DESIGN_SYSTEM.md QD10); this keeps
// this file's import path and the size and colour it always drew, so its callers render exactly as before.
/** A stroked tick, 12 × 9: the customer-profile card's consent checkboxes. */
export function CheckMarkIcon({ color = "#FFFFFF" }: { color?: string }) {
  return <CheckMark size={9} color={color} />;
}

CheckMarkIcon.displayName = "CheckMarkIcon";
export default CheckMarkIcon;
